import { crudActions } from "./CrudActions"

export default {
  ...crudActions("qualitats-psicomotrius"),
}
